import { useTheme } from '@mui/material/styles';

import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { useIsDesktop } from '@vk-hr-tek/ui/hooks';
import {
  EmptyStateImage,
  EmptyStateMode,
} from '@vk-hr-tek/app-ui/EmptyStateImage';

type IProps = {
  title: string;
  noImg?: boolean;
  noBorder?: boolean;
  mode?: EmptyStateMode;
};

export const EmptyListPlug = ({
  title,
  noImg,
  noBorder,
  mode = 'list',
}: IProps) => {
  const theme = useTheme();
  const isDesktop = useIsDesktop();

  return (
    <Box
      bgcolor="bg.light.primary"
      border={
        noBorder
          ? ''
          : `${theme.tokens.border.s}px solid ${theme.tokens.colors.stroke.primary}`
      }
      overflow="hidden"
      radius="l"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="20"
      py="56"
      mx={isDesktop ? '0' : '16'}
    >
      {!noImg && <EmptyStateImage mode={mode} />}
      <Box maxWidth={isDesktop ? '100%' : '214px'}>
        <Typography
          align="center"
          variant={isDesktop ? 'body2' : 'body3'}
          color="text.light.secondary"
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
};
